.hint{font-size:calc(var(--ag-font-size) - 2px);margin-left:5px}
/*# sourceMappingURL=group-cell-renderer.component-YFJW3BXZ.css.map */
